/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState, useEffect, ReactElement, useContext } from 'react'

import {
  CheckOutlined,
  EditOutlined,
  RedoOutlined,
  ReloadOutlined,
  SyncOutlined,
} from '@ant-design/icons'
import { Row, Col, Table, Form, PageHeader, Spin } from 'antd'
import { ColumnsType } from 'antd/lib/table'
import { SelectFieldAnt, SelectItemProps } from 'Components/Form/Select'
import ID_COMPONENTE from 'config/idComponente'
import { ApplicationContext } from 'Context'
import EntidadeSistemaEnum from 'Enumerations/EntidadeSistemaEnum'
import TipoCotaEnum from 'Enumerations/TipoCotaEnum'
import Claims from 'Hooks/usePermissions/Claims'
import usePermissions from 'Hooks/usePermissions/usePermissions'
import { Empresa } from 'Models/cadastros'
import { IArmazem } from 'Models/docas'
import IArmazemCota from 'Models/docas/IArmazemCota'
import IFormArmazemCotaFilter from 'Models/docas/IFormArmazemCotaFilter'
import IFormArmazemCotaInput from 'Models/docas/IFormArmazemCotaInput'
import moment from 'moment'
import { useForm } from 'react-hook-form'
import { ParamsRequest } from 'Services/__shared/types/resquest'
import WsCadastroService from 'Services/WS_CADASTRO'
import WsDocasService from 'Services/WS_DOCAS'
import swal from 'sweetalert'
import IFormEmpresasFilter from 'Views/Cadastros/Empresas/IFormEmpresasFilter'

interface IProps {
  armazem: Partial<IArmazem>
}

const ModalStatusTransportadoras = ({ armazem }: IProps): ReactElement => {
  const { isAuthorized } = usePermissions()

  const verificaColunas = () => {
    const colunas: ColumnsType<IArmazemCota> = [
      {
        title: 'Nome',
        key: 'nome',
        dataIndex: 'nome',
      },
      {
        title: 'CNPJ',
        key: 'cnpj',
        dataIndex: 'cnpj',
      },
      {
        title: 'Status',
        key: 'cotaTipo',
        dataIndex: 'cotaTipo',
        // render: (cotaTipo: string, transportadora: IArmazemCota) =>
        //   verificaStatus(transportadora),
        //Regra explicada no bug 62169 do TFS
      },
      {
        title: 'Data de Atualização',
        key: 'dtAtualizacao',
        dataIndex: 'dtAtualizacao',
      },
      {
        title: 'Usuário',
        key: 'nomeUsuario',
        dataIndex: 'nomeUsuario',
      },
    ]

    if (isAuthorized(Claims.EditarStatusTransportadorasBiomassa)) {
      colunas.unshift({
        title: '',
        key: 'cdTransportadoraBiomassa',
        dataIndex: 'cdTransportadoraBiomassa',
        width: '25px',
        render: (
          cdTransportadoraBiomassa: number,
          transportadora: IArmazemCota,
        ) =>
          transportadora.cdAgendamentoDocasArmazemCotaTipo !==
            TipoCotaEnum.NaoControlaCota && (
            <span
              style={{ cursor: 'pointer' }}
              title="Atualizar Status"
              onClick={() => setTranportadoraSelecionada(transportadora)}
            >
              <EditOutlined />
            </span>
          ),
      })
    }

    return colunas
  }

  const verificaStatus = (transportadora: IArmazemCota) => {
    //Regra explicada no bug 62169 do TFS
    if (transportadora.cdEntidadeSistema === EntidadeSistemaEnum.Adami) {
      const dtAtualizacao: moment.Moment = moment(
        transportadora.dtAtualizacao,
        'DD/MM/YYYY HH:mm:ss',
      )
      const diferencaDias: number = moment().diff(dtAtualizacao, 'days')

      return diferencaDias < 7 ? (
        transportadora.cotaTipo
      ) : (
        <>
          <span style={{ color: 'red' }}>Com Cota</span>
          <SyncOutlined
            onClick={() => renovaCota(transportadora)}
            style={{ color: 'black', cursor: 'pointer', marginLeft: '6px' }}
            title="Renovar status"
          />
        </>
      )
    } else {
      return transportadora.cotaTipo
    }
  }

  const { applicationContext, setApplicationContext } =
    useContext(ApplicationContext)

  const hookForm = useForm()
  const [titulo] = useState<string>(
    `Transportadoras do Armazém ${armazem.nomeArmazem ?? ''}`,
  )
  const [colunas] = useState<ColumnsType<IArmazemCota>>(verificaColunas())
  const [cdTransportadoraSelecionada, setCdTransportadoraSelecionada] =
    useState<number>()
  const [transportadoras, setTransportadoras] = useState<IArmazemCota[]>([])
  const [transportadoraSelecionada, setTranportadoraSelecionada] =
    useState<IArmazemCota>()
  const [carregandoPesquisa, setCarregandoPesquisa] = useState<boolean>(false)
  const [carregandoAtualizacao, setCarregandoAtualizacao] =
    useState<boolean>(false)

  const [selectTransportadoraItens, setSelectTransportadoraItens] = useState<
    SelectItemProps[]
  >([])

  const buscaTransportadorasUsuario = async (
    cdsTransportadorasUsuario: number[],
  ) => {
    const filtros: IFormEmpresasFilter = {
      ativo: true,
    }

    const parametros: ParamsRequest = {
      pageSize: 10000,
      pageNumber: 1,
    }

    const { data } = await WsCadastroService.empresas.getList(
      ID_COMPONENTE.DOCAS,
      filtros,
      parametros,
    )

    if (data.items) {
      const selectTransportadorasData: SelectItemProps[] = data.items
        //TODO: Ver uma forma de chamar o endpoint de buscar empresas passando os CdsEntidades
        .filter((transp) => cdsTransportadorasUsuario.includes(transp.id))
        .map((item: Empresa) => {
          return {
            value: item.id.toString(),
            label: item.nome,
          }
        })

      setSelectTransportadoraItens(selectTransportadorasData)
    }
  }

  const confirmaAtualizacaoCota = async () => {
    if (transportadoraSelecionada) {
      const novoStatus: boolean =
        transportadoraSelecionada.cdAgendamentoDocasArmazemCotaTipo !==
        TipoCotaEnum.ComCota

      const novoStatusString: string = novoStatus ? 'Com Cota' : 'Sem Cota'

      swal({
        title: `Transportadora ${transportadoraSelecionada.nome}`,
        text: `Deseja alterar o status para ${novoStatusString}?`,
        icon: 'warning',
        buttons: ['NÃO', 'SIM'],
      }).then(async (atualizacaoConfirmada) => {
        if (atualizacaoConfirmada) {
          await atualizaCota(novoStatus, transportadoraSelecionada)
        }
      })
    }
  }

  const atualizaCota = async (
    novoStatus: boolean,
    transportadora: IArmazemCota,
  ) => {
    setCarregandoAtualizacao(true)

    try {
      const dadosAtualizacao: IFormArmazemCotaInput = {
        cdAgendamentoDocasArmazemCota:
          transportadora.cdAgendamentoDocasArmazemCota,
        cdAgendamentoDocasArmazemCotaTipo: novoStatus
          ? TipoCotaEnum.ComCota
          : TipoCotaEnum.SemCota,
      }

      await WsDocasService.armazemCota.atualizaCota(
        ID_COMPONENTE.DOCAS,
        dadosAtualizacao,
      )

      await pesquisaTransportadoras(
        transportadora.cdAgendamentoDocasArmazem,
        cdTransportadoraSelecionada,
      )
    } catch (e) {
      console.error(e)

      window.alert(
        'Ocorreu um erro ao atualizar a transportadora, favor contatar o suporte do Compulog',
      )
    }

    setCarregandoAtualizacao(false)
  }

  const renovaCota = async (transportadora: IArmazemCota) => {
    swal({
      title: `Transportadora ${transportadora.nome}`,
      text: `Deseja renovar o status de cota?`,
      icon: 'warning',
      buttons: ['NÃO', 'SIM'],
    }).then(async (renovacaoConfirmada) => {
      if (renovacaoConfirmada) {
        await atualizaCota(true, transportadora)
      }
    })
  }

  const pesquisaTransportadoras = async (
    cdArmazem: number,
    cdTransportadora?: number,
  ) => {
    setCarregandoPesquisa(true)

    const filtros: IFormArmazemCotaFilter = { cdArmazem }

    if (cdTransportadora) {
      filtros.cdTransportadora = cdTransportadora
    }

    const { data } = await WsDocasService.armazemCota.buscaCotas(
      ID_COMPONENTE.DOCAS,
      filtros,
    )

    if (data.items) {
      setTransportadoras(data.items)
    } else {
      setTransportadoras([])
    }

    setCarregandoPesquisa(false)
  }

  useEffect(() => {
    if (armazem.cdAgendamentoDocasArmazem) {
      if (
        applicationContext.usuarioAtual?.cdsTransportadoras &&
        applicationContext.usuarioAtual.cdsTransportadoras.length > 0
      ) {
        if (applicationContext.usuarioAtual.cdsTransportadoras.length === 1) {
          setCdTransportadoraSelecionada(
            applicationContext.usuarioAtual.cdsTransportadoras[0],
          )
        } else {
          buscaTransportadorasUsuario(
            applicationContext.usuarioAtual.cdsTransportadoras,
          )
        }
      }
    }
  }, [])

  useEffect(() => {
    if (
      armazem.cdAgendamentoDocasArmazem &&
      (cdTransportadoraSelecionada ||
        !applicationContext.usuarioAtual?.cdsTransportadoras)
    ) {
      pesquisaTransportadoras(
        armazem.cdAgendamentoDocasArmazem,
        cdTransportadoraSelecionada,
      )
    }
  }, [cdTransportadoraSelecionada])

  useEffect(() => {
    confirmaAtualizacaoCota()
  }, [transportadoraSelecionada])

  return (
    <>
      <PageHeader
        ghost={false}
        title={titulo}
        //Regra explicada no bug 62169 do TFS
        // subTitle={
        //   <span>
        //     O status Com Cota expira depois de 7 dias. Para renová-lo, clique no
        //     botão <SyncOutlined />
        //   </span>
        // }
      ></PageHeader>

      {selectTransportadoraItens.length > 0 && (
        <Row>
          <Col span={24}>
            <SelectFieldAnt
              methods={hookForm}
              scope="form-status-transportadora"
              label="Transportadora:"
              name="cdTransportadora"
              items={selectTransportadoraItens}
              showSearch={true}
              onChangeValue={(value: string) =>
                setCdTransportadoraSelecionada(window.parseInt(value))
              }
            />
          </Col>
        </Row>
      )}

      <Row>
        <Col span={24}>
          {(carregandoAtualizacao || carregandoPesquisa) && (
            <div
              style={{
                textAlign: 'center',
                marginTop: '-27px',
              }}
            >
              <Spin />
            </div>
          )}
          <Table
            size="small"
            pagination={false}
            scroll={{ y: 550 }}
            columns={colunas}
            dataSource={transportadoras}
          />
        </Col>
      </Row>
    </>
  )
}

export default ModalStatusTransportadoras
